<template>
  <div>
    <div v-if="$store.state.user && $store.state.user.supportLogin" class="support-banner" role="status">
      {{ $t('Support session as') }} {{ $store.state.user.email }}
      <button type="button" @click="endSupportLogin">{{ $t('End support session') }}</button>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  methods: {
    endSupportLogin() {
      this.$store.commit('logout');
      this.$router.replace('/support-login');
    }
  }
};
</script>

<style>
.support-banner { position: relative; z-index: 1000; background: #fff3cd; color: #222; padding: 10px; text-align: center; }
.support-banner button { margin-left: 12px; text-decoration: underline; }
</style>
